import client from '@/api/client'

async function recallTicket ({ service, queueSlug, ticket }) {
  const response = await client.post(`/services/${service}/queues/${queueSlug}/tickets/${ticket}/recall-ticket`)
  return { ticket: response.data }
}

async function skipTicket ({ service, queueSlug, ticket }) {
  const response = await client.put(`/services/${service}/queues/${queueSlug}/tickets/${ticket}/skip-ticket`)
  return {
    ticket: response.data
  }
}

async function attendTicket ({ service, queueSlug, ticket, username }) {
  let response
  if (username) {
    response = await client.post(`/services/${service}/queues/${queueSlug}/tickets/${ticket}/attend-ticket`,
      { userAttended: username }
    )
  } else {
    response = await client.post(`/services/${service}/queues/${queueSlug}/tickets/${ticket}/attend-ticket`)
  }
  return {
    ticket: response.data
  }
}

async function closeTicket ({ service, queueSlug, ticket }) {
  const response = await client.post(`/services/${service}/queues/${queueSlug}/tickets/${ticket}/close-ticket`)
  if (response.status === 200) {
    return { ticket: response.data }
  } else {
    return { ticket: null }
  }
}

async function pauseTicket ({ service, queueSlug, ticket }) {
  const response = await client.post(`/services/${service}/queues/${queueSlug}/tickets/${ticket}/pause-ticket`)
  if (response.status === 200) {
    return { ticket: response.data }
  } else {
    return { ticket: null }
  }
}

async function takeTicket ({ serviceID, queueSlug, number }) {
  const response = await client.put(
    `services/${serviceID}/queues/${queueSlug}/tickets/take-ticket`,
    {
      ticketNumber: number
    }
  )
  return { ticket: response.data }
}

async function assignUser ({ serviceID, queueSlug, username, ticketID }) {
  const response = await client.put(`services/${serviceID}/queues/${queueSlug}/tickets/${ticketID}/assign-user`, { userAttended: username })
  return { ticket: response.data }
}

async function callNextTicket ({ service, queueSlug }) {
  let response
  if (queueSlug === null) {
    response = await client.post(`/services/${service}/next-ticket-call`)
  } else {
    response = await client.post(`/services/${service}/queues/${queueSlug}/next-ticket-call`
    )
  }
  if (response.status === 201) {
    return { calledTicket: response.data }
  }
  return null
}

async function getTicket ({ service, letter, ticketNumber }) {
  let response = await client.get(`/services/${service}/queues/${letter}/tickets`, {
    params: {
      ticketNumber
    }
  })
  if (response.status === 200) {
    return response.data
  }
  throw new Error(response)
}

export default {
  recallTicket,
  skipTicket,
  attendTicket,
  pauseTicket,
  takeTicket,
  closeTicket,
  callNextTicket,
  getTicket,
  assignUser
}
